import { render } from "./ApexChartsGraph.vue?vue&type=template&id=4b2629c5&scoped=true"
import script from "./ApexChartsGraph.vue?vue&type=script&lang=ts"
export * from "./ApexChartsGraph.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4b2629c5"

export default script